<template>
     <div class="today">
        <div class="today-title">今日事件</div>
        <div style="height:18vh;width:30.83vw;">
            <Charts id="chartOption4" :option="chartOption4"></Charts>
        </div>
        <div class="Category row-center">
            <div class="item">今日事件<span>{{todayCall.num}}</span></div>
            <div class="item">昨日事件<span>{{todayCall.yesterday}}</span></div>
            <div class="item">增长率<span>{{Number(todayCall.rate).toFixed(2)}}<span style="font-size:16rem;margin:0">%</span></span></div>
        </div>
    </div>
</template>

<script>

import Charts from "./Charts.vue";
import {
    dateFormat,
    dayEnd,
    dayStart,
    nextDay,
    nextMonth,
    nextYear,
    perDay,
    perMonth,
    perYear,
} from "../../util/DateUtil";
import { AlarmStatistics,EventCount } from '../../api/power.js'
     export default {
         data(){
             return {
                todayCall:{
                    num:0,
                    yesterday:0,
                    rate:0
                },
                todayData:[],
                todayDataInfo:{},
             }
         },
         components:{
            Charts
         },
         computed:{
            chartOption4(){
                return {
                   color: [  "#0D94FF","#FF5555","#F5AA00"],
                    tooltip: {
                        trigger: "item",
                    },
                    graphic:{       //图形中间文字
                        type:"text",
                        left:"center",
                        top:"center",
                        style:{
                            text:this.todayDataInfo.sum,
                            textAlign:"center",
                            fontSize:30,
                        }
                    },
                    series: [
                    {
                        // name: "访问来源",
                        type: "pie",
                        radius: ["50%", "70%"],
                        label: {
                            formatter: "{name|{b}}:{time|{c}}",
                            minMargin: 5,
                            edgeDistance: 10,
                            lineHeight: 25,
                            fontSize:"16rem",
                            fontWeight: 800,
                            rich: {
                                time: {
                                    fontSize: "16rem",
                                    // color: "#0D94FF"
                                },
                                name: {
                                    fontSize: "16rem",
                                    // color: "#0D94FF"
                                },
                            },
                        },
                        itemStyle: { // 此配置
                            normal: {
                                borderWidth: 1,
                                borderColor: '#ffffff',
                            },
                            // emphasis: {
                            //     borderWidth: 0,
                            //     shadowBlur: 1,
                            //     shadowOffsetX: 0,
                            //     shadowColor: 'rgba(0, 0, 0, 0.1)'
                            // }
                        },
                        labelLine: {
                            // length: 30,
                            // length2: 100,
                            show: true,
                            lineStyle:{
                                width:2
                            }
                            // color: "#00ffff",
                        },
                        data: this.todayData
                    },
                    ]
                }
            },
            
            projectId(){
                return this.$store.getters.projectId
            },
         },
         mounted(){
            this.getAlarmStatistics();
         },
         watch: {
            projectId(n,o){
                this.getAlarmStatistics();
            }
         },
         methods:{
            async getAlarmStatistics(){
                // fault: 0  故障报警
                // hiddenDanger: 0  隐患
                // messageNotice: 0 信息通报
                // notice: 7 通知
                // operation: 0  操作命令
                // other: 0  其他
                // overrun: 0 越限异常
                // protections: 0 保护动作
                // sum: 7 总
                // switchDisplacement: 7  开关变位
                // urgent: 0 紧急
                let result = await EventCount({
                    start: dayStart(new Date()).replace(/\-/g,'/').split("T")[0],
					end: dayEnd(new Date()).replace(/\-/g,'/').split("T")[0],
                    projectId: this.$store.state.project.projectInfo.projectId
                });
                
                let data = result.data.data.eventNum.all
                this.todayDataInfo = data
                this.todayData = [
                    { value: data.notice, name: "通知",label:{color:"#0D94FF"}},
                    { value: data.urgent, name: "紧急" ,label:{color:"#FF5555"}},
                    { value: data.hiddenDanger, name: "隐患" ,label:{color:"#F5AA00"}}
                ]
                //昨日数据
                let day1 = new Date();
                day1.setDate(day1.getDate() - 1);
                let obj = {
                    start: dayStart(day1).replace(/\-/g,'/').split("T")[0],
					end: dayEnd(day1).replace(/\-/g,'/').split("T")[0],
                    projectId: this.$store.state.project.projectInfo.projectId
                }
                let result1 = await EventCount(obj);
                // console.log(obj,"result1")
                let data1 = result1.data.data.eventNum.all
                this.todayCall.num = data.sum
                this.todayCall.yesterday = data1.sum
                if(this.todayCall.num==0&&this.todayCall.yesterday==0){
                    this.todayCall.rate = 0
                }else if(this.todayCall.yesterday==0){
                    this.todayCall.rate = 100
                }else{
                    this.todayCall.rate = (this.todayCall.num-this.todayCall.yesterday)/this.todayCall.yesterday*100
                }
                
            },
         }
     }
     </script>
<style lang="less" scoped>
.Category{
    height: 8vh;
    line-height: 8vh;
    text-align: center;
    font-size: 18rem;
    color: #666;
    // margin-top: 30rem;
    justify-content: space-between;
    padding: 0rem 30rem;
    .item{
        // width: 33%;
        span{
            font-size: 24rem;
            font-weight: bold;
            color: #0D94FF;
            margin-left: 13rem;
            vertical-align: -2px;
        }
    }
}
    .today{
        position: relative;
        .today-title{
            font-size: 18rem;
            font-weight: bold;
            padding: 23rem 0 0 23rem;
        }
        .more{
            text-align: center;
            color: #999999;
            font-size: 14rem;
            line-height: 5vh;
            cursor: pointer;
            display: block;
            text-decoration:none;
        }
        .more:hover{
            color: #0D94FF;
        }
        .message{
            border-top: 1px solid rgba(0, 0, 0, 0.08);
            background: rgba(0, 43, 102, 0.02);
            .h(200);
            .item{
                height: 48rem;
                font-size: 18rem;
                padding: 0 20rem;
                justify-content: end;
                img{
                    width: 16px;
                }
                span{
                    color: #999999;
                    font-size: 14rem;
                    width: 55px;
                }
                .name{
                    color: #666666;
                    width: 280rem;
                    white-space:nowrap;
                    overflow:hidden;
                    text-overflow:ellipsis;
                    margin-left: 10rem;
                    margin-right: 10rem;
                }
                .statue{
                    width: 150rem;
                    text-align: center;
                }
                .site{
                    color: #999999;

                }
            }
            .item:nth-child(odd){     //偶数行
                background:rgba(0, 43, 102, 0.03);
            }
        }
        
    }
</style>